import { InspectPinMode, Map as MainMap, MapLayer } from '@/map'

export function Map() {
  return (
    <MainMap selectionContext="crud" selectionCategory="simulations" mapId="ww-map">
      <InspectPinMode mode="none" />
      <MapLayer uid="order" />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" />
      {/* TODO: Add remaining layers once they are implemented */}
    </MainMap>
  )
}
